/* Colonne lave-vaisselle sur mesure - moood.fr */
(function(){
'use strict';
var TVA=1.2;
var COEF_QUINCAILLERIE=1.05;
var STRUCTURE_BASE=200;
var STRUCTURE_PAR_MONTANT=50;
var STRUCTURE_COEF={blanc:1,gris:1.2,bois:1.4};
var MECANISME_TIROIR=49.90;
var STRUCTURE_LABEL={blanc:'Blanc',gris:'Gris anthracite',bois:'Couleur au choix'};
var HLV=825;
var EPAISSEUR_STRUCTURE=16;
var EPAISSEUR_FACADE=19;
var VIDE_SANITAIRE=40;
var JEU_FACADE_HAUTEUR=3;
var JEU_FACADE_LARGEUR=5;
var LLV=600;
var FACADE_OVERHANG=110;
var E=19;
var H_AVEC=[138,158,173,185,278,298,318,338,348,398,448,478,498,558,598,698,798,898,998,1298,1318,1498,1798,2198,2498];
var H_INT=[138,158,173,185,278,298,318,338,348,398,448,478,498,558,598,698,798,898,998,1198];
var L15=[100,147,197,247,297,347,397,447,497,597,697,797,897,997,1197];
var L16=[100,147,197,247,297,347,397,447,497,597,647,697,797,897,997,1197];
var P103=[[null,null,null,null,9.11,9.59,9.99,10.42,10.88,11.73,12.91,13.45,14.41,15.37,17.27],[null,null,null,null,9.42,9.93,10.47,10.94,11.42,13.69,16.11,16.69,17.71,18.78,19.35],[null,null,null,null,9.69,10.25,10.78,11.31,11.82,15.17,17.71,18.8,20.25,20.98,21.86],[null,null,null,null,9.85,10.42,11.01,11.57,12.11,15.29,17.86,18.87,20.37,21.03,22.22],[null,null,null,10.71,11.5,12.3,13.14,13.97,14.75,16.36,19.09,19.67,21.19,21.4,25.66],[6.65,9.26,9.83,10.99,11.87,12.74,13.57,14.41,15.3,16.99,19.88,20.57,22.2,22.41,26.88],[6.75,9.32,9.86,11.02,12.01,12.79,13.91,14.66,15.45,17.35,20.27,21.04,22.68,23.37,28.12],[6.98,9.34,9.9,11.08,12.13,12.82,14.19,14.89,15.59,17.67,20.62,21.48,23.18,23.94,28.67],[7.11,9.77,10.51,11.73,12.74,13.7,14.7,15.68,16.69,18.66,21.77,22.8,24.62,24.82,29.8],[7.52,10.17,11.13,12.44,13.57,14.7,15.86,16.94,18.09,20.31,23.69,25.03,27.03,27.28,32.73],[8.0,10.7,11.82,13.2,14.41,15.68,16.96,18.19,19.46,21.96,25.63,27.25,29.45,29.72,35.66],[8.29,10.88,12.22,13.56,14.81,16.15,17.65,18.94,20.29,22.94,26.77,28.45,30.59,32.18,38.62],[8.42,11.13,13.14,13.92,15.3,16.69,18.09,19.46,20.82,23.6,27.52,29.49,31.9,32.99,39.45],[8.94,11.28,13.52,14.22,15.72,17.18,18.66,20.16,21.6,24.59,28.68,29.51,33.46,35.11,42.19],[9.32,11.39,14.1,14.49,16.03,17.61,19.17,20.69,22.29,25.37,29.59,31.1,34.67,37.06,44.49],[10.17,12.6,15.05,15.29,17.02,18.73,20.54,22.22,23.94,27.47,32.19,35.13,37.82,41.98,50.38],[11.65,14.41,16.52,16.72,18.71,20.67,22.66,24.61,26.59,30.59,35.7,40.2,42.23,51.78,62.14],[15.65,16.11,17.85,18.03,20.17,22.4,24.59,26.77,28.98,33.41,39.21,43.26,46.63,52.31,63.82],[17.39,17.9,19.74,20.05,22.4,24.9,27.32,29.76,32.2,37.12,43.56,48.07,51.81,56.96,68.37],[18.09,18.21,20.24,23.26,26.43,29.59,32.75,35.88,39.05,45.35,53.18,59.45,64.33,71.35,85.64],[18.15,18.27,20.65,23.53,26.73,29.95,33.16,36.33,39.55,45.94,53.9,60.3,65.2,72.32,86.81],[18.62,18.72,24.33,25.91,29.55,33.19,36.84,40.47,44.11,51.35,60.26,67.88,73.13,81.14,97.42],[19.37,21.54,26.31,28.81,34.55,39.35,40.85,44.7,53.1,64.8,75.61,77.66,81.81,90.83,108.97],[27.81,28.79,31.51,35.25,42.27,53.67,58.24,70.59,76.72,81.6,93.41,97.86,101.34,111.09,133.38],[28.77,30.5,35.37,37.82,49.29,59.38,64.61,71.97,79.62,89.04,101.1,106.71,118.71,126.27,151.55]];
var P100=[[null,null,null,null,9.79,10.29,10.71,11.18,11.67,12.63,13.86,14.42,15.48,16.51,18.56,21.43],[null,null,null,null,10.13,10.66,11.21,11.73,12.27,14.71,17.3,17.91,19.03,20.13,22.32,25.79],[null,null,null,null,10.41,11.01,11.58,12.16,12.72,16.31,19.03,20.19,21.75,22.41,26.62,30.77],[null,null,null,null,10.61,11.2,11.82,12.42,13.01,16.43,19.16,20.29,21.87,22.48,26.71,30.85],[null,null,null,11.5,12.35,13.2,14.13,15.0,15.85,17.57,20.48,21.11,22.77,22.98,27.58,31.85],[7.16,9.94,10.58,11.81,12.77,13.67,14.57,15.48,16.46,18.27,21.36,22.1,23.85,24.07,28.87,33.33],[7.25,10.01,10.61,11.85,12.89,13.72,14.94,15.74,16.58,18.62,21.76,22.59,24.37,25.12,30.2,34.9],[7.44,10.04,10.65,11.91,13.01,13.75,15.24,16.0,16.74,18.98,22.17,23.07,24.89,25.68,30.76,35.54],[7.64,10.49,11.29,12.63,13.67,14.73,15.79,16.85,17.91,20.06,23.37,24.5,26.46,26.67,32.0,36.97],[8.06,10.93,11.97,13.37,14.57,15.79,17.01,18.19,19.46,21.78,25.43,26.89,29.03,29.28,35.14,40.58],[8.58,11.49,12.72,14.17,15.48,16.85,18.22,19.55,20.92,23.59,27.53,29.23,31.63,31.91,38.3,44.22],[8.9,11.67,13.11,14.56,15.92,17.34,18.96,20.34,21.77,24.64,28.74,30.56,32.83,34.56,41.47,47.9],[9.04,11.97,14.13,14.95,16.46,17.91,19.46,20.92,22.36,25.35,29.57,31.65,34.24,35.98,43.64,50.4],[9.63,12.13,14.51,15.28,16.87,18.45,20.06,21.67,23.2,26.39,30.77,31.68,35.95,37.71,45.31,52.31],[10.01,12.25,14.89,15.56,17.23,18.91,20.57,22.24,23.93,27.26,31.8,33.38,37.23,39.81,47.79,55.19],[10.93,13.52,15.8,16.43,18.31,20.15,22.03,23.87,25.7,29.5,34.57,37.74,40.6,45.08,54.1,62.47],[12.49,15.48,17.43,17.93,20.09,22.22,24.35,26.45,28.54,32.86,38.33,43.17,45.34,55.58,66.71,77.06],[16.8,17.3,19.16,19.37,21.68,24.06,26.39,28.74,31.13,35.89,42.1,46.44,50.07,58.03,70.09,80.97],[18.65,19.22,21.21,21.54,24.06,26.73,29.33,31.96,34.58,39.87,46.78,51.64,55.61,61.17,73.4,84.78],[18.96,19.25,21.74,24.98,28.38,31.8,35.16,38.56,41.94,48.7,57.12,63.84,69.08,76.62,91.97,106.22],[19.04,19.34,22.2,25.27,28.72,32.14,35.58,39.03,42.49,49.35,57.87,64.73,70.02,77.67,93.22,107.68],[19.75,20.1,26.11,27.83,31.73,35.64,39.55,43.46,47.37,55.12,64.7,72.88,78.53,87.12,104.6,120.82],[20.83,23.13,28.27,30.96,37.13,42.26,43.87,48.01,57.01,69.56,81.2,83.39,87.86,97.53,117.01,135.15],[29.84,30.95,33.84,37.86,45.4,57.65,62.54,75.81,82.41,87.62,100.31,105.08,108.82,119.32,143.23,165.44],[30.92,32.75,37.98,40.6,52.91,63.77,69.38,77.29,85.51,95.62,108.54,114.6,127.49,135.59,162.74,187.96]];
var P101=[[null,null,null,null,10.13,11.37,12.55,13.65,14.73,16.69,19.52,21.09,22.37,24.29,29.16,33.35],[null,null,null,null,10.79,12.35,13.59,14.88,15.76,17.97,20.68,23.49,23.55,27.11,32.56,37.24],[null,null,null,null,11.64,13.06,14.44,15.76,17.03,19.4,21.78,24.55,24.74,28.34,34.03,38.92],[null,null,null,null,11.97,13.43,14.86,16.2,17.51,20.0,22.47,25.25,25.59,29.14,34.98,40.02],[null,null,null,12.98,14.52,16.27,18.01,19.69,21.23,24.47,27.9,30.67,32.09,35.41,42.46,48.56],[10.3,12.8,13.23,13.32,15.1,16.92,18.7,20.42,22.03,25.15,29.04,31.8,32.92,36.63,43.99,50.32],[11.2,13.18,14.02,14.18,15.97,18.12,19.64,20.98,23.45,26.78,30.38,34.68,35.22,39.94,47.98,54.87],[11.48,13.56,14.4,14.59,16.76,18.84,20.86,22.76,24.6,28.11,31.28,35.52,36.81,40.92,49.13,56.2],[11.75,13.77,14.67,14.96,16.92,19.34,21.41,23.33,25.25,28.82,31.82,36.46,37.75,42.0,50.39,57.63],[12.8,14.7,15.82,16.15,18.7,21.41,23.21,25.22,27.14,29.99,33.35,38.43,40.33,44.85,53.82,61.55],[13.82,15.64,16.97,17.57,20.42,23.33,25.22,27.53,29.7,32.83,36.46,42.16,44.25,49.25,59.1,67.6],[14.78,16.2,17.89,18.27,21.26,24.31,26.06,28.43,30.83,34.01,38.04,45.24,45.61,52.88,63.47,72.59],[14.82,16.49,18.06,18.84,22.03,25.25,27.14,29.7,32.18,35.59,39.42,45.71,48.05,53.42,64.14,73.37],[16.02,17.65,19.45,20.42,23.71,26.54,29.46,32.27,35.01,40.17,43.11,50.95,52.97,58.88,70.68,80.84],[16.33,18.35,20.0,20.78,25.15,28.82,29.99,32.83,35.59,40.83,45.17,52.56,55.29,61.53,73.85,84.47],[18.1,20.14,22.08,23.1,26.54,29.95,33.15,36.28,39.25,44.93,50.58,58.44,62.02,69.0,82.82,94.74],[20.71,22.13,24.79,26.01,29.66,33.66,36.92,41.09,44.59,51.81,57.12,66.83,68.75,78.88,94.66,108.26],[21.86,23.59,26.28,27.78,32.92,37.75,40.33,44.25,48.05,55.29,62.34,72.29,77.07,85.8,102.97,117.79],[24.29,26.16,29.19,30.84,36.55,41.94,44.77,49.07,53.34,61.36,71.63,80.39,85.5,95.36,114.45,130.9],[30.08,33.73,36.81,38.32,44.59,50.74,56.79,62.71,68.54,79.88,85.92,105.69,113.9,126.62,152.0,173.84],[33.1,36.29,40.05,41.11,48.38,54.41,61.67,67.69,73.74,85.7,92.97,117.43,123.33,140.88,169.14,193.46],[34.21,37.95,41.61,43.56,50.82,57.98,65.02,71.98,78.8,92.17,99.1,122.33,132.25,146.98,176.39,201.76],[40.42,42.78,48.13,51.46,60.17,68.8,77.38,85.8,94.19,110.62,118.91,136.84,139.05,154.64,185.64,212.32],[47.29,51.38,58.4,66.73,74.18,82.87,89.25,106.52,118.39,124.66,135.52,161.9,175.56,189.2,227.16,259.82],[48.43,56.06,65.15,73.23,81.56,90.23,99.05,109.09,121.19,141.53,146.94,190.1,202.46,214.84,257.9,294.98]];
var P102=[[null,null,null,null,12.26,13.73,15.16,16.51,17.85,20.31,22.93,26.45,27.61,30.69,36.86,42.15],[null,null,null,null,13.54,14.87,15.9,17.33,19.14,21.4,25.15,27.43,28.24,33.84,40.64,46.48],[null,null,null,null,13.93,15.62,17.24,18.8,20.34,23.22,26.99,30.21,31.74,35.02,42.04,48.1],[null,null,null,null,14.32,16.03,17.72,19.33,20.9,23.87,27.44,31.0,32.46,35.95,43.16,49.36],[null,null,null,15.23,17.4,19.42,21.44,23.35,25.19,29.0,30.87,37.2,38.34,43.06,51.68,59.12],[10.91,13.18,14.27,15.84,18.08,20.17,22.24,24.22,26.12,29.76,32.02,38.5,39.25,44.49,53.43,61.13],[11.82,13.65,15.47,16.73,19.15,21.45,23.46,25.31,27.59,30.37,35.48,41.99,42.68,48.24,57.91,66.25],[12.06,14.01,15.76,17.54,20.0,22.36,24.6,26.81,28.91,32.97,38.56,42.6,43.38,49.17,59.0,67.49],[12.34,14.21,16.15,17.94,20.85,22.87,25.21,27.43,29.61,33.74,40.08,43.6,44.4,50.31,60.4,69.08],[13.41,15.2,17.55,19.39,22.24,25.21,27.28,29.59,31.82,35.24,41.33,45.99,47.35,53.6,64.32,73.57],[14.5,16.17,18.99,21.1,24.22,27.43,29.59,32.22,34.71,38.42,42.68,50.14,51.64,58.45,70.16,80.25],[15.49,16.66,20.27,22.01,25.27,28.73,30.12,34.04,36.0,39.65,44.54,53.99,54.83,62.63,75.16,85.98],[15.59,17.12,20.38,22.64,26.12,29.61,31.82,34.71,37.41,41.49,45.99,54.13,55.79,63.17,75.79,86.68],[16.88,18.27,22.03,24.54,28.12,31.28,34.48,37.63,40.65,46.44,49.92,59.89,61.11,69.17,83.02,94.96],[17.28,19.01,22.55,25.13,29.76,33.74,35.24,38.42,41.49,47.37,53.75,61.82,65.21,72.15,86.61,99.04],[19.84,20.98,25.42,27.96,31.77,35.48,39.03,42.46,45.75,52.14,57.44,68.57,71.23,80.55,96.7,110.62],[22.69,22.78,29.06,31.13,33.47,39.73,42.09,46.08,52.15,56.15,62.99,71.38,76.59,92.09,110.56,126.45],[24.07,24.7,30.73,33.78,39.25,44.4,47.35,51.64,55.79,63.76,68.56,84.18,87.7,99.2,119.08,136.21],[27.82,28.14,34.14,37.81,43.95,49.61,52.9,57.62,62.26,71.07,82.97,93.53,97.57,110.23,132.33,151.37],[31.9,34.93,41.71,46.41,53.07,59.65,66.09,72.46,78.65,90.82,97.67,120.92,127.27,143.67,172.49,197.29],[35.06,38.39,45.87,49.8,56.71,63.83,70.85,76.85,84.34,98.19,104.98,134.02,137.61,159.44,191.42,218.93],[37.67,41.63,47.37,52.74,60.42,68.0,75.49,82.83,90.1,104.33,112.27,139.3,147.02,165.91,199.17,227.82],[42.75,44.6,55.92,62.26,71.42,80.52,89.59,98.45,107.27,124.64,134.02,156.33,164.94,176.31,211.68,242.11],[50.14,53.22,68.43,70.1,80.52,92.99,96.68,121.69,134.01,140.53,153.49,171.04,194.88,215.71,258.99,296.24],[51.34,58.16,77.67,79.67,91.45,105.85,114.68,132.76,138.72,159.56,167.43,194.12,224.73,244.96,294.07,336.35]];
var P106=[[null,null,null,null,11.78,13.06,14.35,15.58,16.84,19.28,21.71,24.34,26.46,28.87,33.57],[null,null,null,null,12.07,13.32,14.63,15.88,17.1,19.58,22.02,24.72,26.87,29.26,34.03],[null,null,null,null,12.23,13.48,14.77,16.04,17.34,19.82,22.3,24.97,27.16,29.56,34.35],[null,null,null,null,12.35,13.66,14.92,16.24,17.49,19.96,22.45,25.16,27.34,29.77,34.65],[null,null,null,14.88,16.97,19.02,21.07,23.13,25.13,29.07,33.02,37.38,40.94,44.52,52.63],[null,null,null,15.06,17.16,19.21,21.22,23.29,25.28,29.35,33.34,37.61,41.21,45.13,52.9],[null,null,null,15.19,17.34,19.36,21.47,23.5,25.54,29.56,33.54,37.7,41.45,45.43,53.27],[null,null,null,15.34,17.45,19.53,21.63,23.67,25.73,29.77,33.77,38.13,41.75,45.69,53.59],[null,null,null,15.44,17.54,19.65,21.71,23.77,25.79,29.86,33.93,38.29,41.89,45.87,53.74],[null,null,null,15.79,17.94,20.05,22.15,24.24,26.29,30.37,34.18,38.75,42.54,46.55,54.54],[null,null,null,16.16,18.27,20.44,22.55,24.7,26.8,30.92,35.01,39.5,43.16,47.22,55.29],[null,null,null,19.93,22.85,25.76,28.6,31.48,34.31,39.62,45.57,51.63,56.71,62.25,73.27],[null,null,null,20.05,23.02,25.88,28.77,31.64,34.46,40.15,45.79,51.87,56.92,62.5,73.54],[null,null,null,20.44,23.41,26.33,29.26,32.14,34.71,40.74,46.38,52.56,57.68,63.23,74.46],[null,null,null,20.69,23.67,26.64,29.56,32.48,35.38,41.1,46.83,52.99,58.11,63.78,75.02],[null,null,null,21.33,24.35,27.34,30.01,33.28,36.2,42.0,47.84,54.09,59.29,65.01,76.38],[null,null,null,24.78,28.43,31.73,35.64,39.24,42.83,49.87,56.92,64.55,70.94,77.91,91.8],[null,null,null,25.34,29.04,32.72,36.35,39.99,43.61,50.76,57.89,65.63,72.05,79.08,93.15],[null,null,null,27.56,31.65,35.7,39.75,43.76,47.75,55.66,63.58,72.11,79.29,87.02,102.61],[null,null,null,32.05,36.88,41.72,46.52,51.28,56.02,65.46,74.92,85.13,93.66,102.9,121.53]];
var P104=[[null,null,null,null,12.4,13.75,15.1,16.4,17.73,20.29,22.85,25.62,27.85,30.39,35.34],[null,null,null,null,12.7,14.02,15.4,16.72,18.0,20.61,23.18,26.02,28.28,30.8,35.82],[null,null,null,null,12.87,14.19,15.55,16.88,18.25,20.86,23.47,26.28,28.59,31.12,36.16],[null,null,null,null,13.0,14.38,15.71,17.09,18.41,21.01,23.63,26.48,28.78,31.34,36.47],[null,null,null,15.66,17.86,20.02,22.18,24.35,26.45,30.6,34.76,39.35,43.09,46.86,55.4],[null,null,null,15.85,18.06,20.22,22.34,24.52,26.61,30.89,35.09,39.59,43.38,47.51,55.68],[null,null,null,15.99,18.25,20.38,22.6,24.74,26.88,31.12,35.31,39.68,43.63,47.82,56.07],[null,null,null,16.15,18.37,20.56,22.77,24.92,27.08,31.34,35.55,40.14,43.95,48.09,56.41],[null,null,null,16.25,18.46,20.68,22.85,25.02,27.15,31.43,35.72,40.3,44.09,48.28,56.57],[null,null,null,16.62,18.88,21.1,23.32,25.52,27.67,31.97,35.98,40.79,44.78,49.0,57.41],[null,null,null,17.01,19.23,21.52,23.74,26.0,28.21,32.55,36.85,41.58,45.43,49.7,58.2],[null,null,null,20.98,24.05,27.12,30.11,33.14,36.12,41.71,47.97,54.35,59.69,65.53,77.13],[null,null,null,21.1,24.23,27.24,30.28,33.3,36.27,42.26,48.2,54.6,59.92,65.79,77.41],[null,null,null,21.52,24.64,27.72,30.8,33.83,36.54,42.88,48.82,55.33,60.72,66.56,78.38],[null,null,null,21.78,24.92,28.04,31.12,34.19,37.24,43.26,49.29,55.78,61.17,67.14,78.97],[null,null,null,22.45,25.63,28.78,31.59,35.03,38.1,44.21,50.36,56.94,62.41,68.43,80.4],[null,null,null,26.08,29.93,33.4,37.52,41.31,45.08,52.49,59.92,67.95,74.67,82.01,96.63],[null,null,null,26.67,30.57,34.44,38.26,42.09,45.9,53.43,60.94,69.08,75.84,83.24,98.05],[null,null,null,29.01,33.32,37.58,41.84,46.06,50.26,58.59,66.93,75.91,83.46,91.6,108.01],[null,null,null,33.74,38.82,43.92,48.97,53.98,58.97,68.91,78.86,89.61,98.59,108.32,127.93]];
var P105=[[null,null,null,null,16.03,18.01,19.91,21.83,23.75,27.5,31.28,35.35,38.67,42.41,49.77],[null,null,null,null,16.34,18.32,20.26,22.16,24.09,27.91,31.69,35.79,39.19,42.95,50.39],[null,null,null,null,16.53,18.55,20.47,22.44,24.37,28.22,32.04,36.18,39.58,43.33,50.77],[null,null,null,null,16.7,18.73,20.69,22.63,24.59,28.45,32.25,36.42,39.87,43.62,51.15],[null,null,null,20.65,23.79,26.91,30.04,33.14,36.25,42.37,48.47,55.09,60.59,66.34,78.75],[null,null,null,20.83,24.01,27.14,30.28,33.43,36.49,42.69,48.82,55.46,61.01,67.1,79.18],[null,null,null,21.01,24.22,27.37,30.57,33.63,36.8,42.95,49.16,55.64,61.18,67.51,79.67],[null,null,null,21.22,24.43,27.6,30.77,33.91,37.04,43.27,49.44,56.17,61.78,67.88,80.13],[null,null,null,21.32,24.55,27.73,30.9,34.05,37.17,43.41,49.63,56.36,61.97,68.11,80.35],[null,null,null,21.78,25.05,28.26,31.49,34.7,37.85,44.16,50.13,57.07,62.88,69.12,81.51],[null,null,null,22.23,25.55,28.78,32.04,35.24,38.48,44.84,51.19,58.1,63.8,70.07,82.62],[null,null,null,28.51,33.01,37.52,41.98,46.41,50.84,59.35,68.48,78.04,86.03,94.76,112.19],[null,null,null,28.67,33.19,37.71,42.21,46.67,51.12,59.97,68.78,78.37,86.4,95.12,112.6],[null,null,null,29.18,33.75,38.31,42.8,47.35,51.51,60.79,69.7,79.34,87.41,96.29,113.94],[null,null,null,29.51,34.13,38.67,43.27,47.79,52.31,61.32,70.25,79.98,88.17,97.0,114.79],[null,null,null,30.34,35.02,39.65,43.98,48.91,53.46,62.61,71.77,81.59,89.83,98.83,116.85],[null,null,null,35.9,41.6,47.0,52.98,58.64,64.23,75.47,86.62,98.7,108.87,119.92,142.06],[null,null,null,36.66,42.46,48.24,53.98,59.65,65.35,76.68,87.99,100.26,110.54,121.72,144.12],[null,null,null,39.85,46.15,52.49,58.77,65.0,71.25,83.69,96.08,109.53,120.81,133.06,157.67],[null,null,null,46.14,53.57,60.95,68.36,75.69,83.03,97.69,112.23,128.06,141.37,155.76,184.74]];
var TARIFS={
melamine_avec:{H:H_AVEC,L:L15,P:P103},
texture_avec:{H:H_AVEC,L:L16,P:P100},
brillant_avec:{H:H_AVEC,L:L16,P:P101},
mat_avec:{H:H_AVEC,L:L16,P:P102},
melamine_int:{H:H_INT,L:L15,P:P106},
texture_int:{H:H_INT,L:L15,P:P104},
laque_int:{H:H_INT,L:L15,P:P105}
};
var _poignee='avec';
var _finition='texture';
var _couleur='';
var _variantMap={};
var _colGauche='oui';
var _colDroite='oui';
var _gorge='non';
var _caissonCouleur='blanc';
var _structureColors=[];
var _structureColorPrecise='';
var VISIBLE_KEYS=['fac_tiroir','porte_ch'];

var COMPONENTS=[
{key:'mg',label:'Montant gauche',idH:'moo-clv-mg-h',idL:'moo-clv-mg-l',hintH:'moo-clv-mg-h-hint',hintL:'moo-clv-mg-l-hint',group:'montants'},
{key:'md',label:'Montant droit',idH:'moo-clv-md-h',idL:'moo-clv-md-l',hintH:'moo-clv-md-h-hint',hintL:'moo-clv-md-l-hint',group:'montants'},
{key:'cb_dessus',label:'Caisson bas - Dessus',idH:'moo-clv-cb_dessus-h',idL:'moo-clv-cb_dessus-l',hintH:'moo-clv-cb_dessus-h-hint',hintL:'moo-clv-cb_dessus-l-hint',group:'cb'},
{key:'cb_dessous',label:'Caisson bas - Dessous',idH:'moo-clv-cb_dessous-h',idL:'moo-clv-cb_dessous-l',hintH:'moo-clv-cb_dessous-h-hint',hintL:'moo-clv-cb_dessous-l-hint',group:'cb'},
{key:'cb_cg',label:'Caisson bas - Côté gauche',idH:'moo-clv-cb_cg-h',idL:'moo-clv-cb_cg-l',hintH:'moo-clv-cb_cg-h-hint',hintL:'moo-clv-cb_cg-l-hint',group:'cb'},
{key:'cb_cd',label:'Caisson bas - Côté droit',idH:'moo-clv-cb_cd-h',idL:'moo-clv-cb_cd-l',hintH:'moo-clv-cb_cd-h-hint',hintL:'moo-clv-cb_cd-l-hint',group:'cb'},
{key:'cb_fond',label:'Caisson bas - Fond',idH:'moo-clv-cb_fond-h',idL:'moo-clv-cb_fond-l',hintH:'moo-clv-cb_fond-h-hint',hintL:'moo-clv-cb_fond-l-hint',group:'cb'},
{key:'fac_tiroir',label:'Façade tiroir',idH:'moo-clv-fac_tiroir-h',idL:'moo-clv-fac_tiroir-l',hintH:'moo-clv-fac_tiroir-h-hint',hintL:'moo-clv-fac_tiroir-l-hint',group:'fac'},
{key:'ch_dessus',label:'Caisson haut - Dessus',idH:'moo-clv-ch_dessus-h',idL:'moo-clv-ch_dessus-l',hintH:'moo-clv-ch_dessus-h-hint',hintL:'moo-clv-ch_dessus-l-hint',group:'ch'},
{key:'ch_dessous',label:'Caisson haut - Dessous',idH:'moo-clv-ch_dessous-h',idL:'moo-clv-ch_dessous-l',hintH:'moo-clv-ch_dessous-h-hint',hintL:'moo-clv-ch_dessous-l-hint',group:'ch'},
{key:'ch_cg',label:'Caisson haut - Côté gauche',idH:'moo-clv-ch_cg-h',idL:'moo-clv-ch_cg-l',hintH:'moo-clv-ch_cg-h-hint',hintL:'moo-clv-ch_cg-l-hint',group:'ch'},
{key:'ch_cd',label:'Caisson haut - Côté droit',idH:'moo-clv-ch_cd-h',idL:'moo-clv-ch_cd-l',hintH:'moo-clv-ch_cd-h-hint',hintL:'moo-clv-ch_cd-l-hint',group:'ch'},
{key:'ch_fond',label:'Caisson haut - Fond',idH:'moo-clv-ch_fond-h',idL:'moo-clv-ch_fond-l',hintH:'moo-clv-ch_fond-h-hint',hintL:'moo-clv-ch_fond-l-hint',group:'ch'},
{key:'porte_ch',label:'Porte caisson haut',idH:'moo-clv-porte_ch-h',idL:'moo-clv-porte_ch-l',hintH:'moo-clv-porte_ch-h-hint',hintL:'moo-clv-porte_ch-l-hint',group:'porte'}
];

function detectFinition(title){
var t=(title||'').toLowerCase();
if(t.indexOf('brillant')>-1) return 'brillant';
if(t.indexOf('deco')>-1) return 'melamine';
if(/\bmat\b/.test(t)) return 'mat';
return 'texture';
}
function getTarif(fin,poignee){
var key=fin+'_'+(poignee==='integree'?'int':'avec');
if(key==='brillant_int'||key==='mat_int') key='laque_int';
return TARIFS[key]||TARIFS.melamine_avec;
}
function getFinLabel(fin){
var labels={melamine:'Mélaminé',texture:'Bois texturé / Pierre / Métal',brillant:'Laqué brillant',mat:'Laqué ultra mat'};
return labels[fin]||fin;
}
function getCaissonLabel(){
if(_caissonCouleur==='bois' && _structureColorPrecise) return 'Couleur au choix - '+_structureColorPrecise;
return STRUCTURE_LABEL[_caissonCouleur]||_caissonCouleur;
}
function findIdx(arr,val){for(var i=0;i<arr.length;i++) if(arr[i]>=val) return i; return -1;}
var round2=function(n){return Math.round((n+Number.EPSILON)*100)/100;};
var fmt=function(n){return round2(n).toFixed(2).replace('.',',');};
function setTxt(id,v){var e=document.getElementById(id);if(e) e.textContent=v;}
function setHint(id,txt,cls){var e=document.getElementById(id);if(!e)return;e.textContent=txt;e.className='moo-clv-hint'+(cls?' moo-clv-hint--'+cls:'');}
function setErrInput(id,on){var e=document.getElementById(id);if(!e)return;if(on)e.classList.add('moo-clv-input--error');else e.classList.remove('moo-clv-input--error');}
function findOPC(sel){return document.querySelector(sel);}
function getField1(){return findOPC('.calc-field[data-name="field_1"] input[name="field_1"]')||findOPC('input[name="field_1"]');}
function getField2(){return findOPC('.calc-field[data-name="field_2"] input[name="field_2"]')||findOPC('input[name="field_2"]');}
function setInputVal(el,v){if(!el)return;el.value=v;el.dispatchEvent(new Event('input',{bubbles:true}));el.dispatchEvent(new Event('change',{bubbles:true}));}
function getATC(){return document.querySelector('form[action*="/cart/add"]')||document.querySelector('form');}
var _propCache=new Map();
function ensureProp(name,val){
var form=getATC();if(!form)return;
var inp=_propCache.get(name);
if(!inp||!inp.isConnected){inp=document.createElement('input');inp.type='hidden';inp.name='properties['+name+']';form.appendChild(inp);_propCache.set(name,inp);}
inp.value=val==null?'':String(val);
}
var _lastTotal=null;
function pushOPC(){
if(_lastTotal!=null) setInputVal(getField1(),_lastTotal.toFixed(2));
}
function resetUI(){
var rec=document.getElementById('moo-clv-recap');
if(rec) rec.style.display='none';
setInputVal(getField1(),'');
setInputVal(getField2(),'');
_lastTotal=null;
}
function isComponentActive(comp){
if(comp.key==='mg' && _colGauche==='oui') return false;
if(comp.key==='md' && _colDroite==='oui') return false;
return true;
}
function calcOneComponent(H,L,comp){
setErrInput(comp.idH,false);setErrInput(comp.idL,false);
setHint(comp.hintH,'');setHint(comp.hintL,'');
if(!H||!L) return null;
if(!Number.isInteger(H)||!Number.isInteger(L)) return null;
var tbl=getTarif(_finition,_poignee);
var maxH=tbl.H[tbl.H.length-1];
var ok=true;
if(H<138||H>maxH){
setErrInput(comp.idH,true);
setHint(comp.hintH,'Hors catalogue (138 - '+maxH+' mm)','err');
ok=false;
}
if(L<100||L>1197){
setErrInput(comp.idL,true);
setHint(comp.hintL,'Hors catalogue (100 - 1197 mm)','err');
ok=false;
}
if(!ok) return null;
var hi=findIdx(tbl.H,H),li=findIdx(tbl.L,L);
if(hi<0||li<0||tbl.P[hi][li]==null){
setHint(comp.hintH,'Combinaison non disponible pour cette finition','err');
return null;
}
var pHT=tbl.P[hi][li];
var pTTC=round2(pHT*TVA);
if(pTTC<19.90) pTTC=19.90;
var hRef=tbl.H[hi],lRef=tbl.L[li];
setHint(comp.hintH,H===hRef?'Valeur exacte : '+hRef+'mm':'Tranche : '+hRef+'mm','ok');
setHint(comp.hintL,L===lRef?'Valeur exacte : '+lRef+'mm':'Tranche : '+lRef+'mm','ok');
return pTTC;
}
function update(){
var allValid=true;
var dims={};
var visiblePrices={};
for(var i=0;i<COMPONENTS.length;i++){
var c=COMPONENTS[i];
if(!isComponentActive(c)){
setErrInput(c.idH,false);setErrInput(c.idL,false);
setHint(c.hintH,'');setHint(c.hintL,'');
continue;
}
var hEl=document.getElementById(c.idH);
var lEl=document.getElementById(c.idL);
if(!hEl||!lEl){allValid=false;continue;}
var hRaw=hEl.value,lRaw=lEl.value;
if(!hRaw||!lRaw){
setErrInput(c.idH,false);setErrInput(c.idL,false);
setHint(c.hintH,'');setHint(c.hintL,'');
allValid=false;
continue;
}
var H=parseInt(hRaw,10),L=parseInt(lRaw,10);
dims[c.key]={H:H,L:L};
}
if(!allValid){resetUI();return;}
var totalVisible=0;
for(var j=0;j<VISIBLE_KEYS.length;j++){
var key=VISIBLE_KEYS[j];
var comp=null;
for(var ci=0;ci<COMPONENTS.length;ci++){if(COMPONENTS[ci].key===key){comp=COMPONENTS[ci];break;}}
if(!comp||!dims[key]) continue;
var price=calcOneComponent(dims[key].H,dims[key].L,comp);
if(price===null){resetUI();return;}
visiblePrices[key]=price;
totalVisible+=price;
}
var nbMontants=(_colGauche==='oui'?0:1)+(_colDroite==='oui'?0:1);
var structureBase=STRUCTURE_BASE+nbMontants*STRUCTURE_PAR_MONTANT;
var structureCoef=STRUCTURE_COEF[_caissonCouleur]||1;
var prixStructure=round2(structureBase*structureCoef);
var totalBase=prixStructure+totalVisible;
var avecQuincaillerie=round2(totalBase*COEF_QUINCAILLERIE);
var totalQuincaillerie=round2(avecQuincaillerie-totalBase);
var gorgeSupp=_gorge==='oui'?150:0;
var totalFinal=round2(avecQuincaillerie+MECANISME_TIROIR+gorgeSupp);
_lastTotal=totalFinal;
setTxt('moo-clv-rec-fin',getFinLabel(_finition));
setTxt('moo-clv-rec-couleur',_couleur||'-');
setTxt('moo-clv-rec-caisson',getCaissonLabel()+' ('+nbMontants+' montant'+(nbMontants>1?'s':'')+')');
setTxt('moo-clv-rec-structure',fmt(prixStructure)+' €');
setTxt('moo-clv-rec-fac',dims.fac_tiroir?(dims.fac_tiroir.H+' x '+dims.fac_tiroir.L+' mm — '+fmt(visiblePrices.fac_tiroir||0)+' €'):'-');
setTxt('moo-clv-rec-porte',dims.porte_ch?(dims.porte_ch.H+' x '+dims.porte_ch.L+' mm — '+fmt(visiblePrices.porte_ch||0)+' €'):'-');
setTxt('moo-clv-rec-quincaillerie',fmt(totalQuincaillerie)+' €');
setTxt('moo-clv-total',fmt(totalFinal));
var rec=document.getElementById('moo-clv-recap');
if(rec) rec.style.display='block';
pushOPC();
var hPlancher=parseInt(document.getElementById('moo-clv-h-plancher').value,10)||0;
var ht=parseInt(document.getElementById('moo-clv-ht').value,10)||0;
var pc=parseInt(document.getElementById('moo-clv-pc').value,10)||0;
setInputVal(getField2(),'Colonne lave-vaisselle '+ht+'x'+pc+'mm, plancher LV à '+hPlancher+'mm');
ensureProp('Finition façade',getFinLabel(_finition));
ensureProp('Couleur façade',_couleur||'-');
ensureProp('Couleur caisson',getCaissonLabel());
ensureProp('Hauteur plancher LV',hPlancher+' mm (depuis le sol)');
ensureProp('Hauteur totale colonne',ht+' mm (hors pied)');
ensureProp('Profondeur colonne',pc+' mm');
ensureProp('Lave-vaisselle',LLV+' x '+HLV+' mm (standard)');
ensureProp('Colonne à gauche',_colGauche==='oui'?'Oui (pas de montant gauche)':'Non (montant gauche présent)');
ensureProp('Colonne à droite',_colDroite==='oui'?'Oui (pas de montant droit)':'Non (montant droit présent)');
ensureProp('Poignée',_gorge==='oui'?'Gorge alu':'Avec poignée');
for(var k=0;k<COMPONENTS.length;k++){
var cc=COMPONENTS[k];
if(!isComponentActive(cc)) continue;
if(dims[cc.key]) ensureProp(cc.label,dims[cc.key].H+' x '+dims[cc.key].L+' mm');
}
ensureProp('Épaisseur structure',EPAISSEUR_STRUCTURE+' mm');
ensureProp('Épaisseur façades',EPAISSEUR_FACADE+' mm');
ensureProp('Structure caisson (EUR)',prixStructure.toFixed(2));
ensureProp('Mécanisme tiroir (EUR)',MECANISME_TIROIR.toFixed(2));
ensureProp('Prix TTC (EUR)',totalFinal.toFixed(2));
var propsForCart={"Finition façade":'Finition : '+getFinLabel(_finition),"Couleur façade":'Couleur : '+(_couleur||'-'),"Couleur caisson":'Caisson : '+getCaissonLabel(),"Hauteur plancher LV":'Plancher LV : '+hPlancher+' mm (depuis le sol)',"Hauteur totale colonne":'Hauteur totale : '+ht+' mm (hors pied)',"Profondeur colonne":'Profondeur : '+pc+' mm',"Lave-vaisselle":'LV : '+LLV+' x '+HLV+' mm (standard)',"Colonne à gauche":'Colonne à gauche : '+(_colGauche==='oui'?'Oui':'Non'),"Colonne à droite":'Colonne à droite : '+(_colDroite==='oui'?'Oui':'Non')};
for(var k2=0;k2<COMPONENTS.length;k2++){
var cc2=COMPONENTS[k2];
if(!isComponentActive(cc2)) continue;
if(dims[cc2.key]) propsForCart[cc2.label]=cc2.label+' : '+dims[cc2.key].H+' x '+dims[cc2.key].L+' mm';
}
window._mooClvProps=propsForCart;
}
function updateHMax(){
var tbl=getTarif(_finition,_poignee);
var maxH=tbl.H[tbl.H.length-1];
var hMaxEls=document.querySelectorAll('.moo-clv-h-max');
for(var i=0;i<hMaxEls.length;i++) hMaxEls[i].textContent=maxH;
}
var RE_STRUCT_MEL=/deco/i;
var RE_STRUCT_BOIS=/ch.ne|noyer|eb.ne|bois |textur|structur|stri|sculpt|bross/i;
function renderClvCaissonColors(){
var grid=document.getElementById('moo-clv-caisson-colors-grid');
if(!grid||grid.children.length) return;
var mel=[];var bois=[];
for(var i=0;i<_structureColors.length;i++){
var n=_structureColors[i].name;
if(RE_STRUCT_MEL.test(n)) mel.push(_structureColors[i]);
else if(RE_STRUCT_BOIS.test(n)) bois.push(_structureColors[i]);
}
var html='';
function grp(title,arr){
if(!arr.length) return '';
var h='<div style="width:100%;"><span class="moo-clv-section__label" style="font-size:15px;margin:8px 0 10px;display:block;">'+title+'</span><div style="display:flex;flex-wrap:wrap;gap:8px;">';
for(var j=0;j<arr.length;j++){
var col=arr[j];
var sn=col.name.replace(/&/g,'&amp;').replace(/"/g,'&quot;');
h+='<button type="button" class="moo-clv-caisson-swatch" data-caisson-color="'+sn+'" title="'+sn+'" style="width:46px;display:inline-flex;flex-direction:column;align-items:center;gap:4px;border:none;background:none;cursor:pointer;padding:0;"><span style="width:44px;height:44px;border-radius:50%;border:1.5px solid #12312b;overflow:hidden;display:block;background:#e0dbd3 center/cover no-repeat'+(col.img?(' url('+col.img+')'):'')+';"></span><span style="font-family:Caveat,cursive;font-size:12px;color:#6f7f7b;text-align:center;line-height:1.1;">'+col.name+'</span></button>';
}
h+='</div></div>';
return h;
}
html+=grp('Mélaminé',mel);
html+=grp('Bois texturé',bois);
grid.innerHTML=html;
var sbtns=grid.querySelectorAll('[data-caisson-color]');
for(var k=0;k<sbtns.length;k++){
sbtns[k].addEventListener('click',(function(name){return function(){
_structureColorPrecise=name;
for(var m=0;m<sbtns.length;m++){
var sw=sbtns[m].querySelector('span');
sw.style.boxShadow=sbtns[m].getAttribute('data-caisson-color')===name?'0 0 0 2px #fff,0 0 0 4px #C4622A':'none';
}
var lbl=document.getElementById('moo-clv-caisson-color-label');
if(lbl) lbl.textContent='Caisson : '+name;
update();
};})(sbtns[k].getAttribute('data-caisson-color')));
}
}
fetch('/products/facade-joue-fileur-plinthe-sur-mesure.js').then(function(r){return r.json();}).then(function(p){
var vs=p.variants||[];var seen={};
for(var i=0;i<vs.length;i++){var cn=vs[i].option1||vs[i].title;if(!seen[cn]){seen[cn]=true;_structureColors.push({name:cn,img:vs[i].featured_image?vs[i].featured_image.src:''});}}
}).catch(function(){});
var _overrides = {};
function calcComponentDims(compKey, hPlancher, ht, pc){
var hCh = ht - hPlancher - HLV;
switch(compKey){
case 'mg': return { H: ht, L: pc };
case 'md': return { H: ht, L: pc };
case 'cb_dessus': return { H: pc - VIDE_SANITAIRE, L: LLV };
case 'cb_dessous': return { H: pc - VIDE_SANITAIRE, L: LLV };
case 'cb_cg': return { H: hPlancher - 2*EPAISSEUR_STRUCTURE, L: pc };
case 'cb_cd': return { H: hPlancher - 2*EPAISSEUR_STRUCTURE, L: pc };
case 'cb_fond': return { H: hPlancher - 2*EPAISSEUR_STRUCTURE, L: LLV - 2*EPAISSEUR_STRUCTURE };
case 'fac_tiroir': return { H: hPlancher + FACADE_OVERHANG - JEU_FACADE_HAUTEUR, L: LLV - JEU_FACADE_LARGEUR };
case 'ch_dessus': return { H: pc - VIDE_SANITAIRE, L: LLV };
case 'ch_dessous': return { H: pc - VIDE_SANITAIRE, L: LLV };
case 'ch_cg': return { H: hCh - 2*EPAISSEUR_STRUCTURE, L: pc };
case 'ch_cd': return { H: hCh - 2*EPAISSEUR_STRUCTURE, L: pc };
case 'ch_fond': return { H: hCh - 2*EPAISSEUR_STRUCTURE, L: LLV - 2*EPAISSEUR_STRUCTURE };
case 'porte_ch': return { H: hCh - JEU_FACADE_HAUTEUR, L: LLV - JEU_FACADE_LARGEUR };
}
return { H: 0, L: 0 };
}
function readInputs(){
var hPlancher = parseInt(document.getElementById('moo-clv-h-plancher').value, 10) || 0;
var ht = parseInt(document.getElementById('moo-clv-ht').value, 10) || 0;
var pc = parseInt(document.getElementById('moo-clv-pc').value, 10) || 0;
return { hPlancher: hPlancher, ht: ht, pc: pc };
}
function applyInputsToComponents(){
var v = readInputs();
for (var i = 0; i < COMPONENTS.length; i++){
var comp = COMPONENTS[i];
if (_overrides[comp.key]) continue;
var dims = calcComponentDims(comp.key, v.hPlancher, v.ht, v.pc);
var hEl = document.getElementById(comp.idH);
var lEl = document.getElementById(comp.idL);
if (hEl) hEl.value = dims.H || '';
if (lEl) lEl.value = dims.L || '';
}
update();
}
function applyMontantsToggles(){
var mgSection = document.getElementById('moo-clv-mg-section');
var mdSection = document.getElementById('moo-clv-md-section');
if (mgSection) {
if (_colGauche === 'oui') mgSection.classList.add('moo-clv-section--hidden');
else mgSection.classList.remove('moo-clv-section--hidden');
}
if (mdSection) {
if (_colDroite === 'oui') mdSection.classList.add('moo-clv-section--hidden');
else mdSection.classList.remove('moo-clv-section--hidden');
}
}
function toggleOverride(compKey){
var comp = null;
for (var i = 0; i < COMPONENTS.length; i++){
if (COMPONENTS[i].key === compKey) { comp = COMPONENTS[i]; break; }
}
if (!comp) return;
var hEl = document.getElementById(comp.idH);
var lEl = document.getElementById(comp.idL);
var btn = document.querySelector('.moo-clv-comp__edit[data-comp="' + compKey + '"]');
if (_overrides[compKey]){
delete _overrides[compKey];
if (hEl){ hEl.readOnly = true; hEl.classList.add('moo-clv-input--readonly'); }
if (lEl){ lEl.readOnly = true; lEl.classList.add('moo-clv-input--readonly'); }
if (btn){ btn.textContent = 'Modifier'; btn.classList.remove('moo-clv-comp__edit--active'); }
var v = readInputs();
var dims = calcComponentDims(compKey, v.hPlancher, v.ht, v.pc);
if (hEl) hEl.value = dims.H || '';
if (lEl) lEl.value = dims.L || '';
} else {
_overrides[compKey] = true;
if (hEl){ hEl.readOnly = false; hEl.classList.remove('moo-clv-input--readonly'); }
if (lEl){ lEl.readOnly = false; lEl.classList.remove('moo-clv-input--readonly'); }
if (btn){ btn.textContent = 'Auto'; btn.classList.add('moo-clv-comp__edit--active'); }
}
update();
}
['moo-clv-h-plancher','moo-clv-ht','moo-clv-pc'].forEach(function(id){
var el = document.getElementById(id);
if (el) el.addEventListener('input', applyInputsToComponents);
});
document.querySelectorAll('.moo-clv-btns').forEach(function(group){
var side = group.getAttribute('data-toggle');
if (!side) return;
group.querySelectorAll('.moo-clv-btn').forEach(function(btn){
btn.addEventListener('click', function(){
var val = btn.getAttribute('data-val');
if (side === 'gauche') _colGauche = val;
else if (side === 'droite') _colDroite = val;
else if (side === 'gorge') _gorge = val;
group.querySelectorAll('.moo-clv-btn').forEach(function(b){ b.classList.toggle('moo-clv-btn--active', b === btn); });
applyMontantsToggles();
update();
});
});
});
var caissonColorBtns = document.querySelectorAll('#moo-clv-caisson-color-btns .moo-clv-btn');
caissonColorBtns.forEach(function(btn){
btn.addEventListener('click', function(){
_caissonCouleur = btn.getAttribute('data-color');
caissonColorBtns.forEach(function(b){ b.classList.toggle('moo-clv-btn--active', b === btn); });
var box = document.getElementById('moo-clv-caisson-colors');
if (box) {
if (_caissonCouleur === 'bois') { renderClvCaissonColors(); box.style.display='block'; }
else { box.style.display='none'; _structureColorPrecise=''; }
}
update();
});
});
document.querySelectorAll('.moo-clv-comp__edit').forEach(function(btn){
btn.addEventListener('click', function(){
var key = btn.getAttribute('data-comp');
toggleOverride(key);
});
});
for(var ci=0;ci<COMPONENTS.length;ci++){
var c=COMPONENTS[ci];
var hEl=document.getElementById(c.idH);
var lEl=document.getElementById(c.idL);
if(hEl) hEl.addEventListener('input',update);
if(lEl) lEl.addEventListener('input',update);
}
applyInputsToComponents();
applyMontantsToggles();
fetch('/products/colonne-lave-vaisselle-sur-mesure.js')
.then(function(r){return r.json();})
.then(function(p){
var vs=p.variants||[];
for(var i=0;i<vs.length;i++) _variantMap[vs[i].id]=vs[i].title;
updateFinitionFromForm();
})
.catch(function(){});
function updateFinitionFromForm(){
var inp=document.querySelector('form[action*="/cart/add"] input[name="id"]');
if(!inp) return;
var title='';
var id=parseInt(inp.value,10);
if(_variantMap[id]) title=_variantMap[id];
if(!title){
var selOpt=document.querySelector('variant-selects [data-selected-value],variant-radios input[type="radio"]:checked,select[name="id"] option:checked');
if(selOpt) title=selOpt.textContent||selOpt.dataset.selectedValue||'';
}
_finition=detectFinition(title);
_couleur=(title||'').trim();
updateHMax();
}
var _lastVariantId=null;
setInterval(function(){
var inp=document.querySelector('form[action*="/cart/add"] input[name="id"]');
if(!inp) return;
var currentId=inp.value;
if(currentId && currentId!==_lastVariantId){
_lastVariantId=currentId;
updateFinitionFromForm();
resetUI();
update();
}
},300);
document.addEventListener('change',function(e){
var t=e.target;
if(t.name==='id'||(t.closest&&t.closest('variant-selects,variant-radios,.variant-picker,.product-form__input'))){
setTimeout(function(){updateFinitionFromForm();resetUI();update();},80);
}
},true);
window.addEventListener('variant:change',function(){setTimeout(function(){updateFinitionFromForm();resetUI();update();},80);});
var _retry=setInterval(function(){if(_lastTotal!=null)pushOPC();},400);
setTimeout(function(){clearInterval(_retry);},15000);
var atcForm=getATC();
if(atcForm) atcForm.addEventListener('submit',function(){update();pushOPC();},true);
(function(){
function getProps(){
return window._mooClvProps||null;
}
function tick(){
fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
var clv=cart.items.filter(function(i){return i.handle==='colonne-lave-vaisselle-sur-mesure';});
var unpatched=clv.filter(function(i){return !i.properties["Hauteur plancher LV"];});
var props=getProps();
if(!unpatched.length||!props) return;
unpatched.forEach(function(item){
var merged=Object.assign({},item.properties,props);
fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:item.key,properties:merged})}).then(function(r){return r.json();}).then(function(){});
});
}).catch(function(e){});
}
setInterval(tick,2000);
window.mooClvPatch=tick;
})();
updateHMax();
resetUI();
})();